import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const DepositTableHead = enhance(
  ({ totals, order, orderBy, onRequestSort, roles }) => {
    return (
      <TableHead>
        <TableRow>
          {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
            <TableCell sortDirection={orderBy === 'groupName' ? order : false}>
              <TableSortLabel
                active={orderBy === 'groupName'}
                direction={order}
                onClick={() => {
                  onRequestSort('groupName');
                }}
              >
                運営会社名
              </TableSortLabel>
            </TableCell>
          )}
          <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
            <TableSortLabel
              active={orderBy === 'shopName'}
              direction={order}
              onClick={() => {
                onRequestSort('shopName');
              }}
            >
              店舗名
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'depositDate' ? order : false}>
            <TableSortLabel
              active={orderBy === 'depositDate'}
              direction={order}
              onClick={() => {
                onRequestSort('depositDate');
              }}
            >
              入金日
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'gochiDate' ? order : false}>
            <TableSortLabel
              active={orderBy === 'gochiDate'}
              direction={order}
              onClick={() => {
                onRequestSort('gochiDate');
              }}
            >
              ごち日
            </TableSortLabel>
          </TableCell>
          <TableCell
            sortDirection={orderBy === 'depositStatus' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'depositStatus'}
              direction={order}
              onClick={() => {
                onRequestSort('depositStatus');
              }}
            >
              入金状況
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'gochiTypeStr' ? order : false}>
            <TableSortLabel
              active={orderBy === 'gochiTypeStr'}
              direction={order}
              onClick={() => {
                onRequestSort('gochiTypeStr');
              }}
            >
              ごち種別
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'menu' ? order : false}>
            <TableSortLabel
              active={orderBy === 'menu'}
              direction={order}
              onClick={() => {
                onRequestSort('menu');
              }}
            >
              メニュー名（ごち利用状況 / ごちられ日）
            </TableSortLabel>
          </TableCell>
          <TableCell
            sortDirection={orderBy === 'depositAmount' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'depositAmount'}
              direction={order}
              onClick={() => {
                onRequestSort('depositAmount');
              }}
            >
              入金額
              <br />
              {`(計：${totals.depositAmountTotal})`}
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'amount' ? order : false}>
            <TableSortLabel
              active={orderBy === 'amount'}
              direction={order}
              onClick={() => {
                onRequestSort('amount');
              }}
            >
              入金予定額（税抜金額）
              <br />
              {`(計：${totals.amountTotal + totals.taxAmountTotal}(${
                totals.amountTotal
              }))`}
            </TableSortLabel>
          </TableCell>
          {(roles.isSecretariat || roles.isDeveloper) && (
            <TableCell sortDirection={orderBy === 'fee' ? order : false}>
              <TableSortLabel
                active={orderBy === 'fee'}
                direction={order}
                onClick={() => {
                  onRequestSort('fee');
                }}
              >
                手数料（Stripe / 事務局）
                <br />
                {`(計：${totals.feeAmountTotal}(${
                  totals.stripeFeeAmountTotal
                }/${totals.feeAmountTotal - totals.stripeFeeAmountTotal}))`}
              </TableSortLabel>
            </TableCell>
          )}
          {(roles.isSecretariat || roles.isDeveloper) && (
            <TableCell
              sortDirection={
                orderBy === 'secretariatDepositAmount' ? order : false
              }
            >
              <TableSortLabel
                active={orderBy === 'secretariatDepositAmount'}
                direction={order}
                onClick={() => {
                  onRequestSort('secretariatDepositAmount');
                }}
              >
                事務局入金額
                <br />
                {`(計：${totals.secretariatDepositAmountTotal})`}
              </TableSortLabel>
            </TableCell>
          )}
          {(roles.isSecretariat || roles.isDeveloper) && (
            <TableCell
              sortDirection={
                orderBy === 'secretariatDepositDate' ? order : false
              }
            >
              <TableSortLabel
                active={orderBy === 'secretariatDepositDate'}
                direction={order}
                onClick={() => {
                  onRequestSort('secretariatDepositDate');
                }}
              >
                事務局入金日
              </TableSortLabel>
            </TableCell>
          )}
          {(roles.isSecretariat || roles.isDeveloper) && (
            <TableCell
              sortDirection={
                orderBy === 'secretariatDepositStatus' ? order : false
              }
            >
              <TableSortLabel
                active={orderBy === 'secretariatDepositStatus'}
                direction={order}
                onClick={() => {
                  onRequestSort('secretariatDepositStatus');
                }}
              >
                事務局入金状況
              </TableSortLabel>
            </TableCell>
          )}
        </TableRow>
      </TableHead>
    );
  }
);

export default withStyles(styles)(DepositTableHead);
